/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEventoPayload } from './pratica-evento-payload';


export interface ComponenteAggiuntoPayload extends PraticaEventoPayload { 
    componente_id?: string;
    parentela?: ComponenteAggiuntoPayloadParentelaEnum;
    snapshot_iniziale?: { [key: string]: string; };
}
export enum ComponenteAggiuntoPayloadParentelaEnum {
    AFFIDATARIO = 'AFFIDATARIO',
    ALTRO = 'ALTRO',
    COGNATO = 'COGNATO',
    CONVIVENTE = 'CONVIVENTE',
    CURATORE = 'CURATORE',
    FIGLIO = 'FIGLIO',
    FIGLIA = 'FIGLIA',
    FRATELLO = 'FRATELLO',
    MADRE = 'MADRE',
    MARITO = 'MARITO',
    MOGLIE = 'MOGLIE',
    NIPOTE = 'NIPOTE',
    NONNO = 'NONNO',
    NONNA = 'NONNA',
    PADRE = 'PADRE',
    RICHIEDENTE = 'RICHIEDENTE',
    SCONOSCIUTA = 'SCONOSCIUTA',
    SORELLA = 'SORELLA',
    TUTORE = 'TUTORE',
    ZIO = 'ZIO',
    ZIA = 'ZIA'
};



